module.exports = __webpack_public_path__ + "img/avatar0.472f094e.png";